import uuid from 'uuid/v4'
import { EXACT_MATCH } from '@edulastic/constants/const/evaluationType'
import { cloneDeep } from 'lodash'

import { itemStructure, Q_TYPES } from '../constants'
import { getAlignmentForEduItems } from '../helpers'
import { getDefaultDataByQuestionType } from './getQuestionDefaultData'

export const processShortText = (
  { name, options, commonCoreStandard, depthOfKnowledge, difficultLevel },
  alignmentData,
  grades,
  subjects,
  aiDocExtracted = false
) => {
  const { type, title, ...restData } = cloneDeep(
    getDefaultDataByQuestionType(Q_TYPES.SHORT_TEXT)
  )

  const alignment = getAlignmentForEduItems(alignmentData, commonCoreStandard)

  const item = cloneDeep(itemStructure)
  if (aiDocExtracted) {
    item.aiDocExtracted = true
  }

  item._id = uuid()
  const qId = uuid()

  const [row] = item.rows

  const widget = {
    widgetType: 'question',
    title,
    type,
    reference: qId,
    tabIndex: 0,
  }
  row.widgets.push(widget)

  const responses = options.map((option) => ({
    score: 1,
    value: option.name,
    matchingRule: EXACT_MATCH,
  }))

  const validation = {
    scoringType: EXACT_MATCH,
    validResponse: responses[0],
    altResponses: [],
  }

  return {
    ...item,
    data: {
      questions: [
        {
          ...restData,
          id: qId,
          title,
          type,
          stimulus: name,
          uiStyle: {
            type: 'standard',
          },
          validation,
          multipleResponses: false,
          hints: [],
          itemScore: 1,
          alignment,
          grades,
          subjects,
          depthOfKnowledge,
          authorDifficulty: difficultLevel,
        },
      ],
      resources: [],
    },
  }
}
